import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { P } from '#app/components/typography/p.tsx'
import { Q } from '#app/old_components/typography/q.tsx'
import { sessionKey } from '#app/utils/auth.server.ts'
import { prisma } from '#app/utils/db.server.ts'
import { authSessionStorage } from '#app/utils/session.server.ts'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Q',
}

const component: componentProps = {
	name: 'Q',
	shortName: 'Q',
	fileName: 'q',
	category: 'typography',
	description: ['A short inline quotation.'],
	features: ['Drop-in replacement for the native <q> element.', "Automatically inherits the parent's design tokens (just like a normal q tag)."],
	parts: [
		{
			name: 'Q',
			description: 'A short inline quotation.',
			props: [
				{ name: 'weight', type: 'enum: black, extrabold, bold, semibold, medium, normal, light, extralight, thin', default: 'No default value', description: 'The font weight.' },
				{ name: 'size', type: 'enum: 4xl, 3xl, 2xl, xl, lg, md, sm, xs', default: 'No default value', description: 'The font size.' },
				{ name: 'align', type: 'enum: left, center, or right', default: 'No default value', description: 'The text alignment.' },
				{ name: 'tracking', type: 'enum: tighter, tight, normal, wide, wider, or widest', default: 'size-dependent', description: 'The letter spacing.' },
			],
		},
	],
	usage: `<P>
	When Dave asks HAL to open the pod bay door, HAL answers: <Q>I'm sorry, Dave. I'm afraid I can't do that.</Q>
</P>`,
	styling: `/* ### Typography ### */
@layer components {
	/* Q */
	.q {
		@apply before:content-['“'] after:content-['”'];
	}
}`,
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const authSession = await authSessionStorage.getSession(request.headers.get('cookie'))
	const sessionId = authSession.get(sessionKey)
	const session =
		sessionId ?
			await prisma.session.findUnique({
				select: { user: { select: { id: true, paid: true } } },
				where: { id: sessionId, expirationDate: { gt: new Date() } },
			})
		:	null
	const source = session?.user.paid ? await readSource({ category: component.category, fileName: component.fileName }) : null
	return json({ source })
}

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Features features={features} />
			<Parts parts={parts} />
			<Usage usage={usage} shortName={shortName} />
			<P>
				When Dave asks HAL to open the pod bay door, HAL answers: <Q>I'm sorry, Dave. I'm afraid I can't do that.</Q>
			</P>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
